import React from "react";

import Ukimport from "@/pages/ukimport";

import Ukfaq from "@/pages/ukfaq";
import Contacts from "@/pages/contacts";

function Uk() {
  
  const SectionIconBoxes = () => {
    return (
      <>
        <div className="relative w-full">
          <img
            src="uk.jpg" // Replace with the correct path to your image
            alt="United Kingdom"
            className="h-1/3 w-full object-cover"
          />
          <div className="absolute bottom-5 left-20 text-xl md:text-4xl font-bold text-white drop-shadow-md">
            United Kingdom
          </div>
        </div>

        {/* <section className="py-16 lg:py-24">
          <div className="container mx-auto px-4">
            <h2 className="mb-12 text-center text-3xl font-bold text-gray-800">
              UK Visa Categories
            </h2>
          
          </div>
        </section> */}
        <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
          <p className="mb-5 text-center text-4xl font-bold text-[#011473] md:text-6xl">
            Visa Categories
          </p>

          <div className="container mx-auto mb-10 mt-14">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 xl:grid-cols-3">
              {/* Skilled Migration Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/bussiness.jpg"
                  alt="Skilled Migration Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl text-[#011473] font-medium transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Business Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-md">
                    The UK’s strategic location and progressive policies make it
                    an excellent choice for skilled professionals. This visa
                    allows you to live and work in the UK, opening doors to
                    numerous career opportunities.
                  </p>
                  <a href="/uk-business-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Investor Visa */}

              {/* Student Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-8 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/student.jpg"
                  alt="Student Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Student Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-md">
                    The UK is renowned for its world-class universities. The
                    Student Visa allows you to study at top-tier institutions
                    and provides post-study work opportunities for up to two
                    years.
                  </p>
                  <a href="/uk-student-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Visit Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/visit.jpg"
                  alt="Visit Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Visit Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-md">
                    The UK Visit Visa is ideal for short-term visits for
                    tourism, business, or family visits, providing a flexible
                    option to experience the country’s rich culture and
                    heritage.
                  </p>
                  <a href="/uk-visit-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-6 bg-white p-6 lg:flex-row lg:items-start lg:space-x-12 lg:space-y-0 lg:p-12">
          <div className="w-full flex-shrink-0 lg:w-1/2">
            <img
              src="passport.JPG"
              alt="Person using tablet"
              className="max-w-auto mx-auto h-96 rounded-lg shadow-md md:w-full lg:mx-0"
            />
          </div>

          <div className="w-full space-y-4 text-left lg:w-1/2">
            <ul className="space-y-4 text-gray-800">
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Experience life, work and education across the UK’s diverse
                  regions and cities.
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Benefit from free education for your children in the UK.
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Access comprehensive healthcare and retirement support for you
                  and your family in the UK.
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Benefit from an expedited relocation process to the UK.
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Earn a better income in British pounds, paving the way for
                  financial success.
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Sponsor your loved ones to join you in the UK and enjoy a
                  better quality of life together.
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Enjoy full UK rights and freedoms, ensuring equality and
                  protection for all.
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 h-6 w-6 flex-shrink-0 text-blue-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8.4 8.4a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Receive legal protection and benefit from the UK’s renowned
                  justice system.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <SectionIconBoxes />
      <Ukimport />
      <Ukfaq />
      <Contacts />
    </>
  );
}

export default Uk;
